import Stack from 'components/elements/Stack'
import { getCountryLanguageConfig } from 'lib/constants/countryLanguageConfig'
import TiktokIcon from 'assets/app/my_content/tiktok.svg'
import InstagramIcon from 'assets/app/my_content/instagram.svg'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import theme from 'stories/utils/theme'

const Container = styled(Stack)`
    @media (max-width: 1050px) {
        place-content: center;
    }
`

const SocialIcons = styled.div`
    padding: 5px 10px;
    display: flex;
    gap: 20px;
    justify-content: start;
    align-items: center;
    svg path {
        stroke: ${theme.colors.backgroundSecondary};
    }
    @media (max-width: 1050px) {
        justify-content: center;
    }
`

const GetInTouchSection = () => {
    const { locale } = useRouter()
    const countryLanguageConfig = getCountryLanguageConfig(locale)

    return (
        <Container gutter={10}>
            <SocialIcons>
                {countryLanguageConfig?.instagramUrl ? (
                    <a href={countryLanguageConfig.instagramUrl} target="_blank" rel="noreferrer">
                        <InstagramIcon />
                    </a>
                ) : null}
                {countryLanguageConfig?.tiktokUrl ? (
                    <a href={countryLanguageConfig.tiktokUrl} target="_blank" rel="noreferrer">
                        <TiktokIcon />
                    </a>
                ) : null}
            </SocialIcons>
        </Container>
    )
}

export default GetInTouchSection
